import { CheckOutlined } from "@ant-design/icons";
import "./SelfCampaignProgress.scss";

export type SelfCampaignProgressVariant = "create" | "design" | "activate";

const STEPS_BY_VARIANT: Record<SelfCampaignProgressVariant, string[]> = {
  create: ["Get Started", "Business Info", "Design Campaign", "Activate"],
  design: ["Get Started", "Business Info", "Design Campaign", "Activate"],
  activate: ["Get Started", "Business Info", "Design Campaign", "Activate"],
};

type SelfCampaignProgressProps = {
  title: string;
  activeStep: 1 | 2 | 3 | 4;
  variant: SelfCampaignProgressVariant;
  subtitle?: string;
  caption?: string;
};

const SelfCampaignProgress: React.FC<SelfCampaignProgressProps> = ({
  title,
  activeStep,
  variant,
  subtitle,
  caption,
}) => {
  const stepItems = STEPS_BY_VARIANT[variant];
  const currentStep = Math.min(Math.max(activeStep, 1), 4);
  const filledPercent = `${((currentStep - 1) / 3) * 100}%`;

  return (
    <section className={`self-campaign-progress self-campaign-progress--${variant}`}>
      <h1 className="self-campaign-progress__title">{title}</h1>

      <div className="self-campaign-progress__track">
        <div className="self-campaign-progress__line" />
        <div
          className="self-campaign-progress__line-filled"
          style={{ width: filledPercent }}
        />

        {stepItems.map((label, index) => {
          const stepNumber = index + 1;
          const isDone = stepNumber < currentStep;
          const isActive = stepNumber === currentStep;

          return (
            <div
              key={`${label}-${stepNumber}`}
              className={`self-campaign-progress__step ${
                isDone ? "self-campaign-progress__step--done" : ""
              } ${isActive ? "self-campaign-progress__step--active" : ""}`}
            >
              {isDone ? <CheckOutlined /> : stepNumber}
            </div>
          );
        })}
      </div>

      <div className="self-campaign-progress__labels">
        {stepItems.map((label, index) => {
          const isActive = index + 1 === currentStep;
          return (
            <span
              key={`${label}-label`}
              className={isActive ? "self-campaign-progress__label--active" : ""}
            >
              {label}
            </span>
          );
        })}
      </div>

      {subtitle ? <p className="self-campaign-progress__subtitle">{subtitle}</p> : null}
      {caption ? <p className="self-campaign-progress__caption">{caption}</p> : null}
    </section>
  );
};

export default SelfCampaignProgress;
